import { Avatar } from "@mui/material";

export const BtcIcon = () => (
  <Avatar sx={{ width: 24, height: 24, bgcolor: "#f7931a" }}>
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_17906_113018)">
        <path
          d="M39.3971 24.8381C36.726 35.5525 25.8741 42.0731 15.1584 39.4012C4.44722 36.7301 -2.07335 25.8775 0.598972 15.1639C3.26894 4.44838 14.1209 -2.07268 24.8332 0.59847C35.5481 3.26961 42.0683 14.1234 39.3968 24.8383L39.397 24.8381H39.3971Z"
          fill="url(#paint0_linear_17906_113018)"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M28.8197 17.1506C29.2178 14.489 27.1914 13.0583 24.4206 12.1039L25.3195 8.49857L23.1248 7.95171L22.2498 11.4621C21.6728 11.3182 21.0803 11.1826 20.4914 11.0482L21.3728 7.51463L19.1795 6.96777L18.2801 10.5719C17.8027 10.4632 17.3337 10.3558 16.8787 10.2426L16.8813 10.2312L13.8548 9.47547L13.271 11.8195C13.271 11.8195 14.8992 12.1928 14.8649 12.2157C15.7536 12.4375 15.9144 13.0258 15.8877 13.4922L14.8637 17.5995C14.9249 17.615 15.0043 17.6375 15.0919 17.6727L15.0283 17.6568H15.0282C14.974 17.6432 14.9177 17.6291 14.8599 17.6153L13.4247 23.3691C13.3161 23.6391 13.0405 24.0443 12.4191 23.8904C12.4411 23.9223 10.824 23.4923 10.824 23.4923L9.73438 26.0045L12.5904 26.7165C12.9031 26.7949 13.2122 26.8755 13.5181 26.9552L13.5183 26.9553C13.7321 27.011 13.9442 27.0663 14.1551 27.1202L13.2469 30.7669L15.4391 31.3138L16.3384 27.7058C16.9373 27.8684 17.5185 28.0183 18.0874 28.1597L17.1911 31.7506L19.3858 32.2975L20.2939 28.6577C24.0363 29.3659 26.8503 29.0804 28.0347 25.6954C28.9891 22.9701 27.9872 21.3982 26.0183 20.3731C27.4524 20.0423 28.5325 19.0992 28.8205 17.1509L28.8198 17.1504L28.8197 17.1506ZM23.8053 24.1819C23.183 26.6823 19.2692 25.6486 17.4785 25.1756C17.3175 25.1331 17.1736 25.0951 17.0508 25.0646L18.2559 20.2334C18.4056 20.2708 18.5884 20.3118 18.7956 20.3583C20.6478 20.774 24.4428 21.6256 23.8054 24.1819H23.8053ZM19.1645 18.1165C20.6574 18.5149 23.9142 19.3841 24.4814 17.1115H24.4816C25.0608 14.7873 21.8957 14.0866 20.3499 13.7443C20.176 13.7058 20.0226 13.6719 19.8973 13.6406L18.8047 18.0222C18.9079 18.048 19.0289 18.0803 19.1645 18.1165Z"
          fill="white"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_17906_113018"
          x1="0"
          y1="1.73039e-06"
          x2="0"
          y2="40"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FCC538" />
          <stop offset="1" stopColor="#F7931A" />
        </linearGradient>
        <clipPath id="clip0_17906_113018">
          <rect width="40" height="40" fill="white" />
        </clipPath>
      </defs>
    </svg>
  </Avatar>
);

export const EthIcon = () => (
  <Avatar sx={{ width: 24, height: 24, bgcolor: "#627eea" }}>
    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g clipPath="url(#clip0_17906_113093)">
    <path d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z" fill="#EBF4FF"/>
    <path d="M19.9404 8L19.7812 8.54043V24.221L19.9404 24.3797L27.219 20.0773L19.9404 8Z" fill="#479DFF"/>
    <path d="M19.9428 8L12.6641 20.0773L19.9428 24.3797V16.7688V8Z" fill="#99C9FF"/>
    <path d="M19.9412 25.7572L19.8516 25.8666V31.4522L19.9412 31.714L27.2243 21.457L19.9412 25.7572Z" fill="#005FCC"/>
    <path d="M19.9428 31.715V25.7582L12.6641 21.458L19.9428 31.715Z" fill="#99C9FF"/>
    <path d="M19.9453 24.3795L27.2239 20.077L19.9453 16.7686V24.3795Z" fill="#70B3FF"/>
    <path d="M12.6641 20.077L19.9428 24.3795V16.7686L12.6641 20.077Z" fill="#005FCC"/>
  </g>
  <defs>
    <clipPath id="clip0_17906_113093">
      <rect width="40" height="40" fill="white"/>
    </clipPath>
  </defs>
</svg>

  </Avatar>
);

export const BnbIcon = () => (
  <Avatar sx={{ width: 24, height: 24, bgcolor: "#f3ba2f" }}>
    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z" fill="#F3BA2F"/>
      <path d="M12.5 20L16.25 16.25L20 20L16.25 23.75L12.5 20Z" fill="white"/>
      <path d="M20 20L23.75 16.25L27.5 20L23.75 23.75L20 20Z" fill="white"/>
      <path d="M16.25 20L20 16.25L23.75 20L20 23.75L16.25 20Z" fill="white"/>
    </svg>
  </Avatar>
);

export const SolIcon = () => (
  <Avatar sx={{ width: 24, height: 24, bgcolor: "#14f195" }}>
    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z" fill="#14F195"/>
      <path d="M12.5 15L18.75 12.5L25 15L18.75 17.5L12.5 15Z" fill="white"/>
      <path d="M12.5 25L18.75 22.5L25 25L18.75 27.5L12.5 25Z" fill="white"/>
    </svg>
  </Avatar>
);

export const XrpIcon = () => (
  <Avatar sx={{ width: 24, height: 24, bgcolor: "#23292f" }}>
    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z" fill="#23292F"/>
      <path d="M12.5 15L18.75 20L12.5 25L15 22.5L18.75 20L15 17.5L12.5 15Z" fill="white"/>
      <path d="M27.5 15L21.25 20L27.5 25L25 22.5L21.25 20L25 17.5L27.5 15Z" fill="white"/>
    </svg>
  </Avatar>
);

export const AdaIcon = () => (
  <Avatar sx={{ width: 24, height: 24, bgcolor: "#0033ad" }}>
    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z" fill="#0033AD"/>
      <path d="M20 12.5L25 17.5L20 22.5L15 17.5L20 12.5Z" fill="white"/>
      <path d="M20 27.5L25 32.5L20 37.5L15 32.5L20 27.5Z" fill="white"/>
    </svg>
  </Avatar>
);

export const DogeIcon = () => (
  <Avatar sx={{ width: 24, height: 24, bgcolor: "#c2a633" }}>
    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z" fill="#C2A633"/>
      <path d="M15 15H20V20H15V15Z" fill="white"/>
      <path d="M20 15H25V20H20V15Z" fill="white"/>
      <path d="M15 20H20V25H15V20Z" fill="white"/>
      <path d="M20 20H25V25H20V20Z" fill="white"/>
    </svg>
  </Avatar>
);

export const LtcIcon = () => (
  <Avatar sx={{ width: 24, height: 24, bgcolor: "#a6a9aa" }}>
    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z" fill="#A6A9AA"/>
      <path d="M12.5 15L18.75 12.5L25 15L18.75 17.5L12.5 15Z" fill="white"/>
      <path d="M12.5 25L18.75 22.5L25 25L18.75 27.5L12.5 25Z" fill="white"/>
    </svg>
  </Avatar>
);

export const XmrIcon = () => (
  <Avatar sx={{ width: 24, height: 24, bgcolor: "#f7931e" }}>
    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z" fill="#F7931E"/>
      <path d="M20 12.5C16.5 12.5 13.75 15.25 13.75 18.75C13.75 22.25 16.5 25 20 25C23.5 25 26.25 22.25 26.25 18.75C26.25 15.25 23.5 12.5 20 12.5Z" fill="white"/>
    </svg>
  </Avatar>
);

export const MaticIcon = () => (
  <Avatar sx={{ width: 24, height: 24, bgcolor: "#8247e5" }}>
    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z" fill="#8247E5"/>
      <path d="M12.5 15L18.75 12.5L25 15L18.75 17.5L12.5 15Z" fill="white"/>
      <path d="M12.5 25L18.75 22.5L25 25L18.75 27.5L12.5 25Z" fill="white"/>
    </svg>
  </Avatar>
);

export const TrxIcon = () => (
  <Avatar sx={{ width: 24, height: 24, bgcolor: "#ff6b35" }}>
    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z" fill="#FF6B35"/>
      <path d="M12.5 15L18.75 20L12.5 25L15 22.5L18.75 20L15 17.5L12.5 15Z" fill="white"/>
      <path d="M27.5 15L21.25 20L27.5 25L25 22.5L21.25 20L25 17.5L27.5 15Z" fill="white"/>
    </svg>
  </Avatar>
);

export const UsdIcon = () => (
  <Avatar sx={{ width: 24, height: 24, bgcolor: "#22c55e" }}>
    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z" fill="#22C55E"/>
      <path d="M20 12.5C18.5 12.5 17.5 13.5 17.5 15C17.5 16.5 18.5 17.5 20 17.5C21.5 17.5 22.5 16.5 22.5 15C22.5 13.5 21.5 12.5 20 12.5Z" fill="white"/>
      <path d="M20 22.5C18.5 22.5 17.5 23.5 17.5 25C17.5 26.5 18.5 27.5 20 27.5C21.5 27.5 22.5 26.5 22.5 25C22.5 23.5 21.5 22.5 20 22.5Z" fill="white"/>
    </svg>
  </Avatar>
);

export const EurIcon = () => (
  <Avatar sx={{ width: 24, height: 24, bgcolor: "#3b82f6" }}>
    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z" fill="#3B82F6"/>
      <path d="M20 12.5C18.5 12.5 17.5 13.5 17.5 15C17.5 16.5 18.5 17.5 20 17.5C21.5 17.5 22.5 16.5 22.5 15C22.5 13.5 21.5 12.5 20 12.5Z" fill="white"/>
      <path d="M20 22.5C18.5 22.5 17.5 23.5 17.5 25C17.5 26.5 18.5 27.5 20 27.5C21.5 27.5 22.5 26.5 22.5 25C22.5 23.5 21.5 22.5 20 22.5Z" fill="white"/>
    </svg>
  </Avatar>
);

export const UsdtIcon = () => (
  <Avatar sx={{ width: 24, height: 24, bgcolor: "#22c55e" }}>
    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z" fill="#22C55E"/>
      <path d="M20 12.5C18.5 12.5 17.5 13.5 17.5 15C17.5 16.5 18.5 17.5 20 17.5C21.5 17.5 22.5 16.5 22.5 15C22.5 13.5 21.5 12.5 20 12.5Z" fill="white"/>
      <path d="M20 22.5C18.5 22.5 17.5 23.5 17.5 25C17.5 26.5 18.5 27.5 20 27.5C21.5 27.5 22.5 26.5 22.5 25C22.5 23.5 21.5 22.5 20 22.5Z" fill="white"/>
    </svg>
  </Avatar>
);
